/**
 * This comparator compares the values of object passed with the filter conditions
 */

import Util from './utils';

export default class Comparator {

    private fieldComparators: Map<string, any>;

    constructor() {
        this.compareStringName = this.compareStringName.bind(this);
        this.compareOrganizationValue = this.compareOrganizationValue.bind(this);
        this.fieldComparators = new Map();
        // filter maps for profile
        this.fieldComparators.set('firstname', { comparer: this.compareStrings, accessor: this.getValue });
        this.fieldComparators.set('middlename', { comparer: this.compareStrings, accessor: this.getMetaInfoValue });
        this.fieldComparators.set('lastname', { comparer: this.compareStrings, accessor: this.getValue });
        this.fieldComparators.set('profileID', { comparer: this.compareStrings, accessor: this.getMetaInfoValue });
        this.fieldComparators.set('level', { comparer: this.compareStringContains, accessor: this.getMetaInfoValue });
        this.fieldComparators.set('gender', { comparer: this.compareStringContains, accessor: this.getMetaInfoValue });
        this.fieldComparators.set('concussed', { comparer: this.compareStringTrueOrFalse, accessor: this.getValue });
        this.fieldComparators.set('notifyPhone', {
            comparer: this.compareStringEmptyOrNull,
            accessor: this.getMetaInfoValue
        });
        this.fieldComparators.set('notifyEmail', {
            comparer: this.compareStringEmptyOrNull,
            accessor: this.getMetaInfoValue
        });
        this.fieldComparators.set('organizationname', {
            comparer: this.compareStrings,
            accessor: this.getValue
        });
        // filter maps for test
        this.fieldComparators.set('name', { comparer: this.compareStringName, accessor: this.getName });
        this.fieldComparators.set('startDate', {
            comparer: this.compareStringDateGreater,
            accessor: this.getTestDateTime
        });
        this.fieldComparators.set('endDate', {
            comparer: this.compareStringDateLesser,
            accessor: this.getTestDateTime
        });
        this.fieldComparators.set('baseline', { comparer: this.compareStringBitValue, accessor: this.getValue });
        this.fieldComparators.set('testType', {
            comparer: this.compareStringContains,
            accessor: this.getTestType,
            dependsOn: 'baseline'
        });
        // filter maps for Organization
        this.fieldComparators.set('contactfirstname', { comparer: this.compareStrings, accessor: this.getValue });
        this.fieldComparators.set('contactlastname', { comparer: this.compareStrings, accessor: this.getValue });
        this.fieldComparators.set('contactphone', { comparer: this.compareStrings, accessor: this.getValue });
        this.fieldComparators.set('contactemail', { comparer: this.compareStrings, accessor: this.getValue });

        // filter maps for user
        this.fieldComparators.set('username', { comparer: this.compareStrings, accessor: this.getValue });
        this.fieldComparators.set('email', { comparer: this.compareStrings, accessor: this.getValue });
        this.fieldComparators.set('role', { comparer: this.compareStringContains, accessor: this.getRoleValue });
        this.fieldComparators.set('organizations', {
            comparer: this.compareOrganizationValue,
            accessor: this.getValue
        });

        this.fieldComparators.set('profile', { comparer: this.compareStrings, accessor: this.getValue });
        this.fieldComparators.set('starttime', {
            comparer: this.compareStringDateGreater,
            accessor: this.getDateTime
        });
        this.fieldComparators.set('endtime', {
            comparer: this.compareStringDateEqual,
            accessor: this.getDateTime
        });
    }

    /**
     * Returns true or false based on the filters / objects comparison
     * @param filter filter condition containing the filter keys
     * @param object object that need to be compared
     */
    compare(filter: any, object: any) {
        let success = true;
        Object.keys(filter).forEach((key: string) => {
            if (filter[key] !== '' && !(this.isEmpty(filter[key]))) {
                if (this.fieldComparators.has(key)) {
                    /*let { comparer, accessor } = this.fieldComparators.get(key);
                    success = success && comparer(accessor(object, key), filter[key]);*/
                    success = success && this.executeCompare(
                        this.fieldComparators.get(key),
                        filter, object, key
                    );
                }
            }
        });
        return success;
    }

    executeCompare(comparator: any, filter: any, object: any, key: any) {
        let { comparer, accessor, dependsOn } = comparator;
        // console.log(dependsOn);
        if (dependsOn !== undefined) {
            let success: boolean;
            if (accessor(object, key) === '{IGNORE}') {
                success = filter[dependsOn] !== undefined ? true : false;
                return success;
            }
            return comparer(accessor(object, key), filter[key]);
        } else {
            return comparer(accessor(object, key), filter[key]);
        }
        /*|| (dependsOn !==  undefined ? 
        this.executeCompare(this.fieldComparators.get(dependsOn), filter, object, dependsOn)
        : true);*/
    }

    /**
     * Checks if an object is empty
     * @param obj Object to check if empty
     */
    public isEmpty(obj: any): boolean {
        if (obj instanceof Object) {
            return Object.keys(obj).length === 0 && obj.constructor === Object;
        } else {
            return false;
        }
    }

    /**
     * Compares if the firstValue starts with the secondValue string
     * @param firstValue  String to be compared
     * @param secondValue string part that needs to be searched
     */
    private compareStrings(firstValue: string, secondValue: any): boolean {
        if (firstValue !== undefined && firstValue !== null) {
            return firstValue.trim().toLowerCase().startsWith(secondValue.trim().toLowerCase());
        } else {
            return false;
        }
    }

    /**
     * Finds if the firstValue in present in the array of second value
     * @param firstValue  Value to be searched
     * @param secondValue array in which the value will be searched
     */
    private compareStringContains(firstValue: string, secondValue: any): boolean {
        if (secondValue.length === 0 || firstValue === '{IGNORE}') {
            return true;
        }
        if (firstValue !== undefined && firstValue !== null) {
            // return secondValue.includes(firstValue); // includes not supproted in IE
            return secondValue.indexOf(firstValue) !== -1;
        } else {
            return false;
        }

    }

    /**
     * Identifies if the firstValue is empty, null or undefined based on the secondValue passed
     * @param firstValue Value to be checked
     * @param secondValue  can be 0 - return true if empty, null or undefined,
     *                     1 - return true is vlaue present
     *                     anything else dont compare
     */
    private compareStringEmptyOrNull(firstValue: string, secondValue: any): boolean {
        if (secondValue === 0) {
            return firstValue === undefined || firstValue === null || firstValue === '';
        } else if (secondValue === 1) {

            return !(firstValue === undefined || firstValue === null || firstValue === '');
        }
        return true;
    }

    /**
     * Identifies if the firstvalue is true/false based on the second value passed
     * @param firstValue  value to be checked
     * @param secondValue can be 0 - return true if value is true,
     *                    can be 1 - return true if value is false
     */
    private compareStringTrueOrFalse(firstValue: string, secondValue: any): boolean {
        if (secondValue === 0) {// 0 for yes
            return firstValue ? true : false;
        } else if (secondValue === 1) {// 1 for no
            return !firstValue ? true : false;
        }
        return true;
    }

    /**
     * Identifies if the firstvalue is true/false based on the second value passed
     * @param firstValue value to be checked
     * @param secondValue can be 0 - return true if value is 1,
     *                    can be 1 - return true if value is 0
     */
    private compareStringBitValue(firstValue: string, secondValue: any): boolean {
        if (secondValue === 0) {// 0 for yes
            return firstValue.toString() === '1' ? true : false;
        } else if (secondValue === 1) {// 1 for no
            return firstValue.toString() === '0' ? true : false;
        } else if (secondValue === 2) {// 2 for both
            return true;
        }
        return false;
    }

    private compareStringDateEqual(firstValue: string, secondValue: any): boolean {
        if (secondValue === undefined) {
            return true;
        }
        if (firstValue !== undefined && firstValue !== null) {
            let filterDate = new Date(secondValue);
            let dateInMS = new Date(
                filterDate.getUTCFullYear(),
                filterDate.getUTCMonth(),
                filterDate.getUTCDate()).getTime().toString();
            let testDate = new Date(firstValue);
            let testDateinMs = new Date(
                testDate.getUTCFullYear(),
                testDate.getUTCMonth(),
                testDate.getUTCDate()).getTime().toString();
            if (testDateinMs <= dateInMS) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    private compareStringDateGreater(firstValue: string, secondValue: any): boolean {
        if (secondValue === undefined) {
            return true;
        }
        if (firstValue !== undefined && firstValue !== null) {
            let filterDate = new Date(secondValue);
            let dateInMS = new Date(
                filterDate.getUTCFullYear(),
                filterDate.getUTCMonth(),
                filterDate.getUTCDate()).getTime().toString();
            let testDate = new Date(firstValue);
            let testDateinMs = new Date(
                testDate.getUTCFullYear(),
                testDate.getUTCMonth(),
                testDate.getUTCDate()).getTime().toString();
            if (testDateinMs >= dateInMS) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    private compareStringDateLesser(firstValue: string, secondValue: any): boolean {
        if (secondValue === undefined) {
            return true;
        }
        if (firstValue !== undefined && firstValue !== null) {
            let filterDate = new Date(secondValue);
            let dateInMS = new Date(
                filterDate.getUTCFullYear(),
                filterDate.getUTCMonth(),
                filterDate.getUTCDate()).getTime().toString();
            let testDate = new Date(firstValue);
            let testDateinMs = new Date(
                testDate.getUTCFullYear(),
                testDate.getUTCMonth(),
                testDate.getUTCDate()).getTime().toString();
            if (testDateinMs < dateInMS) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    // private compareStringTestType(obj: any, key: any) {
    //     if (obj.baseline !== 1) {
    //         success = success && comparer( obj.range , obj[key], 1) ;
    //     } else if (filter.baseline === undefined) {
    //         success = success && false;
    //     }
    //     console.log('');
    // }

    private compareStringName(firstValue: any, secondValue: any) {
        if (firstValue !== undefined && firstValue !== null) {
            if (firstValue.firstname !== undefined) {
                return this.compareStrings(firstValue.firstname, secondValue) ||
                    this.compareStrings(firstValue.lastname, secondValue);
            } else {
                return this.compareStrings(firstValue, secondValue);
            }
        } else {
            return false;
        }

    }

    private compareOrganizationValue(firstValue: any, secondValue: any) {
        if (firstValue !== undefined && firstValue !== null) {
            let success: boolean = false;
            firstValue.forEach((e): any => {
                success = success || this.compareStringContains(e.organizationid, secondValue);
            });
            return success;
        } else {
            return false;
        }

    }

    private getMetaInfoValue(obj: any, key: any) {
        return Util.getProfileValue(obj.playerinfo, key);
    }

    private getValue(obj: any, key: any) {
        return obj[key];
    }

    private getTestDateTime(obj: any, key: any) {
        return obj.testtimestamp;
    }

    private getDateTime(obj: any, key: any) {
        return obj.datetime;
    }

    private getTestType(obj: any, key: any) {
        return obj.baseline !== undefined && obj.baseline === 1 ? '{IGNORE}' : obj.range;
    }

    private getName(obj: any, key: any) {
        if (obj.athlete !== undefined) {
            return { firstname: obj.athlete.firstname, lastname: obj.athlete.lastname };
        } else {
            return obj.name;
        }
    }

    private getRoleValue(obj: any, key: any) {
        return obj.roleid;
    }

}


// WEBPACK FOOTER //
// ./src/components/common/comparer.tsx